import apiRoutes from '../constants/apiRoutes';
import baseApi from '../services/api';
export interface AddUserPreferencePayload {
  language: string;
}

export interface UserOnboardingFeedbackPayload {
  text: string;
}

export interface UserConsentPayload {
  authorityConsentAccepted: boolean;
  termsOfServiceAccepted: boolean;
  newsletterOptIn: boolean;
}

const user = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query<any, any>({
      query: () => `${apiRoutes.userDetails}`,
    }),
    addUserPreference: builder.mutation<any, AddUserPreferencePayload>({
      query: (payload) => ({
        url: `${apiRoutes.userPreferences}`,
        method: 'PUT',
        body: payload,
      }),
    }),
    userLogout: builder.mutation<any, any>({
      query: () => ({
        url: `${apiRoutes.userLogout}`,
        method: 'POST',
      }),
    }),
    userOnboardingRequest: builder.mutation<any, any>({
      query: () => ({
        url: `${apiRoutes.onboardingRequest}`,
        method: 'POST',
      }),
    }),
    userOnboardingFeedback: builder.mutation<any, UserOnboardingFeedbackPayload>({
      query: (payload) => ({
        url: `${apiRoutes.onboardingFeedback}`,
        method: 'POST',
        body: payload,
      }),
    }),
    userConsent: builder.mutation<void, UserConsentPayload>({
      query: (payload) => ({
        url: `${apiRoutes.userConsent}`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const {
  useLazyGetUserQuery,
  useAddUserPreferenceMutation,
  useUserLogoutMutation,
  useUserOnboardingRequestMutation,
  useUserOnboardingFeedbackMutation,
  useUserConsentMutation,
} = user;
